import type { Container } from 'pixi.js';
import type { ContainerModel, NestedLayoutModel } from './types/models';

export const copyContainerProps = (container: Container, model: ContainerModel | NestedLayoutModel): void => {
  container.x = model.x;
  container.y = model.y;
  container.scale.x = model.scale.x;
  container.scale.y = model.scale.y;
  container.pivot.x = model.pivot.x;
  container.pivot.y = model.pivot.y;
  container.angle = model.angle;
  container.alpha = model.alpha;
  container.visible = model.visible;
  container.interactive = model.interactive;
  container.eventMode = model.buttonMode ? 'static' : 'auto';
  container.cursor = model.buttonMode ? 'pointer' : 'default';
};
